import { render, staticRenderFns } from "./AutomationDigest.vue?vue&type=template&id=da2fc2e8&"
import script from "./AutomationDigest.vue?vue&type=script&lang=js&"
export * from "./AutomationDigest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports